import * as React from 'react';
import { useMemo } from 'react';
import { useController } from 'react-hook-form';
import { useTreeReferencesContext } from '../../../../tree/references';
import { ComputeExpressionBaseInput } from './ComputeExpressionBaseInput';

export interface IComputeExpressionInputProps {
  name: string;
  widgetId: string;
  /** Se true, include la reference al widget stesso tra quelle selezionabili */
  includeSelf: boolean;
  noFunctions?: boolean;
}

/**
 * Input per la gestione dell'espressione di calcolo
 * tramite l'editor Tiptap
 */
export function ComputeExpressionInput(props: IComputeExpressionInputProps) {
  const { widgetId, includeSelf } = props;
  const {
    field: { value, onChange, onBlur },
  } = useController({ name: props.name });

  const { references } = useTreeReferencesContext();

  const inputReferences = useMemo(() => {
    return references.filter(r => {
      if (r.id === widgetId) {
        return includeSelf;
      }
      return true;
    });
  }, [includeSelf, references, widgetId]);

  return (
    <ComputeExpressionBaseInput
      references={inputReferences}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      noFunctions={props.noFunctions}
    />
  );
}
